// Service
import ClientsService from '../../services/clients.service';
// Reducer
import * as ClientsReducer from './clients.reducers';


// Consult Clients Mis ====================================================================================================

export const consultarClientesMis = (data) => async (dispatch) => {
  dispatch(ClientsReducer.setConsultClientsMisLoading());

  try {

    const response = await ClientsService.consultarClientesMis(data);
    const responseData = response.data?.data?.datosCliente['ns2:DatosClienteAuto'];
    const formattedData = responseData?.length > 0 ? responseData[0] : {};
    formattedData.exists = true;
    formattedData.IsOnboarding = response.data?.onboarding;
    dispatch(ClientsReducer.setConsultClientsMisSuccess(formattedData));
  
  } catch(error) {
    if (error.response?.data?.data?.codigoError === '56886') {
      dispatch(ClientsReducer.setConsultClientsMisSuccess({exists: false}));
    } else {
      dispatch(ClientsReducer.setConsultClientsMisFailure(error.response?.data?.data?.descripcionError || error.message));
    }
  }

}

// Clear Consult Clients Mis Store ====================================================================================================

export const clearConsultarClientesMisStore = () => async (dispatch) => {
  dispatch(ClientsReducer.cleanUpConsultClientsMis());
}


// Consult Client File ====================================================================================================

export const consultaFichaCliente = (data) => async (dispatch) => {
  dispatch(ClientsReducer.setConsultClientsFileLoading());

  try {

    const response = await ClientsService.consultaFichaCliente(data);

    dispatch(ClientsReducer.setConsultClientsFileSuccess(response.data));

  } catch(error) {
    dispatch(ClientsReducer.setConsultClientsFileFailure(error.response?.data?.data?.descripcionError || error.message));
  }

}

// Clear Consult Client File Store ====================================================================================================

export const clearConsultaFichaClienteStore = () => async (dispatch) => {
  dispatch(ClientsReducer.cleanUpConsultClientsFile());
}


// Consult Clients Mis Spouse ====================================================================================================

export const consultarClientesMisConyuge = (data) => async (dispatch) => {
  dispatch(ClientsReducer.setConsultClientsMisSpouseLoading());

  try {

    const response = await ClientsService.consultarClientesMis(data);
    const responseData = response.data?.data?.datosCliente['ns2:DatosClienteAuto'];
    const formattedData = responseData?.length > 0 ? responseData[0] : {};
    formattedData.exists = true;

    dispatch(ClientsReducer.setConsultClientsMisSpouseSuccess(formattedData));

  } catch(error) {
    if (error.response?.data?.data?.codigoError === '56886') {
      dispatch(ClientsReducer.setConsultClientsMisSpouseSuccess({exists: false}));
    } else {
      dispatch(ClientsReducer.setConsultClientsMisSpouseFailure(error.response?.data?.data?.descripcionError || error.message));
    }
  }

}

// Clear Consult Clients Mis Spouse Store ====================================================================================================

export const clearConsultarClientesMisConyugeStore = () => async (dispatch) => {
  dispatch(ClientsReducer.cleanUpConsultClientsMisSpouse());
}


// Consult Clients Mis Representative ====================================================================================================

export const consultarClientesMisApoderado = (data) => async (dispatch) => {
  dispatch(ClientsReducer.setConsultClientsMisRepresentativeLoading());

  try {

    const response = await ClientsService.consultarClientesMis(data);
    const responseData = response.data?.data?.datosCliente['ns2:DatosClienteAuto'];
    const formattedData = responseData?.length > 0 ? responseData[0] : {};
    formattedData.exists = true;

    dispatch(ClientsReducer.setConsultClientsMisRepresentativeSuccess(formattedData));

  } catch(error) {
    if (error.response?.data?.data?.codigoError === '56886') {
      dispatch(ClientsReducer.setConsultClientsMisRepresentativeSuccess({exists: false}));
    } else {
      dispatch(ClientsReducer.setConsultClientsMisRepresentativeFailure(error.response?.data?.data?.descripcionError || error.message));
    }
  }

}

// Clear Consult Clients Mis Representative Store ====================================================================================================

export const clearConsultarClientesMisApoderadoStore = () => async (dispatch) => {
  dispatch(ClientsReducer.cleanUpConsultClientsMisRepresentative());
}


// Register Client ====================================================================================================

export const registroClientes = (data) => async (dispatch) => {
  dispatch(ClientsReducer.setRegisterClientLoading());

  try {

    const response = await ClientsService.registroClientes(data);
    dispatch(ClientsReducer.setRegisterClientSuccess(response.data?.data));

  } catch(error) {
    dispatch(ClientsReducer.setRegisterClientFailure(error.response?.data?.data?.descripcionError || error.message));
  }

}

// Clear Register Client Store ====================================================================================================

export const clearRegistroClientesStore = () => async (dispatch) => {
  dispatch(ClientsReducer.clearRegisterClient());
}



// Register Client Spouse ====================================================================================================

export const registroClientesConyuge = (data) => async (dispatch) => {
  dispatch(ClientsReducer.setRegisterClientSpouseLoading());

  try {
    const response = await ClientsService.registroClientes(data);
    dispatch(ClientsReducer.setRegisterClientSpouseSuccess(response.data?.data));

  } catch(error) {
    dispatch(ClientsReducer.setRegisterClientSpouseFailure(error.response?.data?.data?.descripcionError || error.message));
  }

}


// Clear Register Client Spouse Store ====================================================================================================

export const clearRegistroClientesConyugeStore = () => async (dispatch) => {
  dispatch(ClientsReducer.clearRegisterClientSpouse());
}


// Register Client Representative ====================================================================================================

export const registroClientesApoderado = (data) => async (dispatch) => {
  dispatch(ClientsReducer.setRegisterClientRepresentativeLoading());

  try {

    const response = await ClientsService.registroClientes(data);
    dispatch(ClientsReducer.setRegisterClientRepresentativeSuccess(response.data?.data));

  } catch(error) {
    dispatch(ClientsReducer.setRegisterClientRepresentativeFailure(error.response?.data?.data?.descripcionError || error.message));
  }

}

// Clear Register Client Representative Store ====================================================================================================

export const clearRegistroClientesApoderadoStore = () => async (dispatch) => {
  dispatch(ClientsReducer.clearRegisterClientRepresentative());
}


// Update Natural Client Details ====================================================================================================

export const actualizacionDatosClienteNatural = (data) => async (dispatch) => {
  dispatch(ClientsReducer.setUpdateNaturalClientLoading());

  try {

    const response = await ClientsService.actualizacionDatosClienteNatural(data);
    dispatch(ClientsReducer.setUpdateNaturalClientSuccess(response.data?.data));

  } catch(error) {
    dispatch(ClientsReducer.setUpdateNaturalClientFailure(error.response?.data?.data?.descripcionError || error.message));
  }

}


// Clear Update Natural Client Store ====================================================================================================

export const clearNaturalClientUpdateStore = () => async (dispatch) => {
  dispatch(ClientsReducer.clearUpdateNaturalClientStore());
}


// Insert Registered Client In Backoffice ====================================================================================================

export const insertarClienteEnBackoffice = (data) => async (dispatch) => {
  dispatch(ClientsReducer.setInsertClientInBackOfficeLoading());

  try {

    await ClientsService.insertarClienteEnBackoffice(data);
    dispatch(ClientsReducer.setInsertClientInBackOfficeSuccess());

  } catch(error) {
    dispatch(ClientsReducer.setInsertClientInBackOfficeFailure(error.response?.data?.data?.descripcionError || error.response?.data?.message || error.message));
  }

}


// Clear Insert Registered Client In Backoffice Store ====================================================================================================

export const clearInsertClientInBackOfficeStore = () => async (dispatch) => {
  dispatch(ClientsReducer.clearInsertClientInBackOfficeStore());
}


// Upload Client Constancy Files ====================================================================================================

export const subirArchivosDeConstanciaDelCliente = (data) => async (dispatch) => {
  dispatch(ClientsReducer.setUploadClientFilesToBackOfficeLoading());

  try {

    await ClientsService.subirArchivosDeConstanciaDelCliente(data);
    dispatch(ClientsReducer.setUploadClientFilesToBackOfficeSuccess());

  } catch(error) {
    dispatch(ClientsReducer.setUploadClientFilesToBackOfficeFailure(error.response?.data?.data?.descripcionError || error.response?.data?.message || error.message));
  }

}


// Clear Upload Client Constancy Files Store ====================================================================================================

export const clearUploadClientFilesToBackOfficeStore = () => async (dispatch) => {
  dispatch(ClientsReducer.clearUploadClientFilesToBackOfficeStore());
}


// Generate PDF of Income Declaration ====================================================================================================

export const generateIncomeDeclarationPDF = (data) => async (dispatch) => {
  dispatch(ClientsReducer.setIncomeDeclarationPDFLoading());

  try {

    const response = await ClientsService.generateIncomeDeclarationPDF(data);
    dispatch(ClientsReducer.setIncomeDeclarationPDFSuccess(response.data));

  } catch(error) {
    dispatch(ClientsReducer.setIncomeDeclarationPDFFailure(error.response?.data?.data?.descripcionError || error.response?.data?.message || error.message));
  }

}


// Clear Generate PDF of Income Declaration Store ====================================================================================================

export const clearGenerateIncomeDeclarationPDFStore = () => async (dispatch) => {
  dispatch(ClientsReducer.clearUploadClientFilesToBackOfficeStore());
}